import {Component, OnInit, ViewChild} from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import {DateAdapter, NativeDateAdapter} from '@angular/material/core';
import {AuthService} from '../../core/security/auth.service';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatStepper, MatStep } from '@angular/material/stepper';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import {AccountService} from '../../account/account.service';
import {phoneNumberValidator} from '../../core/validators/phone-number.validator';
import {TwoFactorSetupModel} from '../../api/models/two-factor-setup-model';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { MatPhoneNumberInputComponent } from '../../editors/mat-phone-number-input/mat-phone-number-input.component';
import { MatTextInputComponent } from '../../editors/mat-text-input/mat-text-input.component';

@Component({
    selector: 'app-mat-switch-company-dialog',
    providers: [
        { provide: DateAdapter, useClass: NativeDateAdapter },
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { displayDefaultIndicatorType: false },
        },
    ],
    templateUrl: './two-factor-setup-dialog.component.html',
    styleUrls: ['./two-factor-setup-dialog.component.scss'],
    standalone: true,
    imports: [FlexModule, MatDialogTitle, MatIconButton, MatDialogClose, MatIcon, CdkScrollable, MatDialogContent, MatStepper, MatStep, MatButton, FormsModule, ReactiveFormsModule, NgIf, MatPhoneNumberInputComponent, MatTextInputComponent]
})
export class TwoFactorSetupDialogComponent implements OnInit {


  @ViewChild('stepper') stepper: MatStepper;

  phoneNumberValidators: any[] = [phoneNumberValidator, Validators.required]
  emailValidators: any[] = [Validators.email, Validators.required]
  firstFormGroup = this.fb.group({
    firstCtrl: ['', [Validators.required]],
  });
  secondFormGroup = this.fb.group({
    secondCtrl: ['', [Validators.required]],
    phoneNumberCtrl: ['', []],
    emailCtrl: ['', []],
  });
  thirdFormGroup = this.fb.group({
    verificationTokenCtrl: ['', [Validators.required]],
  });

  isVerificationCompleted = false;
  isVerificationFailed = false;
  selectedTwoFactorProvider: string;
  twoFactorSetupModel: TwoFactorSetupModel | undefined;

  constructor(public dialogRef: MatDialogRef<TwoFactorSetupDialogComponent>,
              public dialog: MatDialog,
              private fb: FormBuilder,
              private authService: AuthService,
              private accountService: AccountService
  ) {

  }

  ngOnInit() {
  }

  closeSendConfirmPopup(action: string) {
    if (action === 'close') {
      this.dialogRef.close();
    } else if (action === 'completed') {
      this.dialogRef.close('completed');
    }
  }

  setTwoAuthProvider(provider: string) {
    this.selectedTwoFactorProvider = provider;
    this.firstFormGroup.patchValue({
      firstCtrl: 'done'
    });

    this.secondFormGroup.controls['phoneNumberCtrl'].clearValidators();
    this.secondFormGroup.controls['phoneNumberCtrl'].updateValueAndValidity();

    this.secondFormGroup.controls['emailCtrl'].clearValidators();
    this.secondFormGroup.controls['emailCtrl'].updateValueAndValidity();

    if (this.selectedTwoFactorProvider == 'authenticator') {
      this.accountService.getTwoFactorSetup(this.selectedTwoFactorProvider).then(value => {
        this.twoFactorSetupModel = value;
      }).catch((err) => {
        console.log(err);
      });
    } else if (this.selectedTwoFactorProvider == 'phoneNumber') {
      this.twoFactorSetupModel = undefined;
      this.secondFormGroup.controls['phoneNumberCtrl'].setValidators(this.phoneNumberValidators);
    } else if (this.selectedTwoFactorProvider == 'email') {
      const user = this.authService.currentUser.getValue()
      this.twoFactorSetupModel = undefined;
      this.secondFormGroup.controls['emailCtrl'].setValidators(this.emailValidators);
      this.secondFormGroup.patchValue({emailCtrl: user.email})
    }

    this.stepper.next();
  }


  nextVerification() {
    this.secondFormGroup.patchValue({
      secondCtrl: 'done'
    });

    this.resendVerificationToken();

    this.stepper.next();
  }

  resendVerificationToken() {
    if (this.selectedTwoFactorProvider == 'phoneNumber') {
      if (this.secondFormGroup.valid) {
        const phoneNumber = this.secondFormGroup.controls['phoneNumberCtrl'].value.toString();
        this.accountService.getTwoFactorSetup(this.selectedTwoFactorProvider, phoneNumber).then(value => {
          this.twoFactorSetupModel = value;
        }).catch((err) => {
          console.log(err);
        });
      }
    } else if (this.selectedTwoFactorProvider == 'email') {
      if (this.secondFormGroup.valid) {
        const emailAddress = this.secondFormGroup.controls['emailCtrl'].value.toString();
        this.accountService.getTwoFactorSetup(this.selectedTwoFactorProvider, emailAddress).then(value => {
          this.twoFactorSetupModel = value;
        }).catch((err) => {
          console.log(err);
        });
      }
    }
  }

  nextVerifyToken() {
    console.log('nextVerifyToken');

    if (this.thirdFormGroup.valid) {
      const token = this.thirdFormGroup.controls['verificationTokenCtrl'].value.toString();
      const destSource = this.selectedTwoFactorProvider == 'phoneNumber' ? this.secondFormGroup.controls['phoneNumberCtrl'].value?.toString()
        : this.selectedTwoFactorProvider == 'email' ? this.secondFormGroup.controls['emailCtrl'].value?.toString() : '';
      this.accountService.getTwoFactorVerify(this.selectedTwoFactorProvider, token, destSource).then(value => {
        this.isVerificationCompleted = value;

        if (value) {
          this.stepper.next();
        } else {
          this.isVerificationFailed = true
        }
      }).catch((err) => {
        console.log(err);
        this.isVerificationCompleted = false;
      });
    }
  }

  previousStep() {
    console.log('previous clicked');
    const previousIndex = this.stepper.selectedIndex - 1;
    const previousStep = this.stepper.steps.get(previousIndex)
    previousStep.editable = true;
    previousStep.reset();
    this.stepper.selected.reset();
    this.stepper.previous();
    previousStep.editable = false;
  }
}
